/**
 * Scroll-reveal: fades sections and product cards up into view as they enter
 * the viewport, using the native IntersectionObserver API (no dependencies).
 *
 * - Fires once per element (unobserves itself after revealing).
 * - Product cards inside the same grid get a small staggered delay.
 * - Does nothing if the browser lacks IntersectionObserver, or the visitor
 *   prefers reduced motion — content simply renders normally either way.
 */
(function () {
  if (!('IntersectionObserver' in window)) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var MAIN_SELECTOR = '#MainContent';
  var STAGGER_STEP_MS = 120;
  var STAGGER_MAX_MS = 600;

  function revealOnIntersect(entries, observer) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('is-revealed');
      observer.unobserve(entry.target);
    });
  }

  function init() {
    var main = document.querySelector(MAIN_SELECTOR);
    if (!main) return;

    var sectionObserver = new IntersectionObserver(revealOnIntersect, {
      threshold: 0.12,
      rootMargin: '0px 0px -8% 0px',
    });

    var cardObserver = new IntersectionObserver(revealOnIntersect, {
      threshold: 0.15,
      rootMargin: '0px 0px -5% 0px',
    });

    // Whole sections (hero, product list, about, testimonials, etc.)
    main.querySelectorAll(':scope > .shopify-section').forEach(function (section) {
      section.classList.add('scroll-reveal');
      sectionObserver.observe(section);
    });

    // Individual product cards, staggered per grid/row they share a parent with.
    var groupCounts = new Map();
    main.querySelectorAll('.product-card').forEach(function (card) {
      var parent = card.parentElement;
      var index = groupCounts.get(parent) || 0;
      groupCounts.set(parent, index + 1);

      var delay = Math.min(index * STAGGER_STEP_MS, STAGGER_MAX_MS);
      card.style.setProperty('--scroll-reveal-delay', delay + 'ms');
      card.classList.add('scroll-reveal');
      cardObserver.observe(card);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
